import { FailureReason } from "shared/multipart-upload/FailureReason";

export type UploadPartInput = {
  etag: string;
  partNumber: number;
};

export type MultipartUpload = {
  caseId: number;
  chunkSize: number;
  partUrls: string[];
  preintakeId: string;
  uploadId: string;
};

export type CompleteCaseDocumentUploadMutationVariables = {
  caseId: number;
  uploadId: string;
  preIntakeId: string;
  parts: UploadPartInput[] | UploadPartInput;
};

export type FileUpload = {
  file: File;
  progress: number;
  bytesSent: number;
  batchId: string;
  state: "idle" | "queued" | "inprogress" | "error" | "success";
  error?: string;
  clientError?: "size_exceeded" | "invalid_type" | "empty_document";
};

export type UploaderArgs = {
  file: File;
  caseId: number;
  batchId: string;
  preserveSectionStateForSections: number[];
  onProgress: (partIndex: number, partProgress: number, partTotal: number, totalSent: number) => void;
  onComplete: () => void;
  onFailure: (reason: FailureReason, errorMessage?: string) => void;
};

export const UploaderConfig = {
  maxUploadSizeBytes: 1024 * 1024 * 2000,
  checkUploadType: (typ: string) => {
    return (
      typ === "application/pdf" ||
      typ === "image/png" ||
      typ === "image/jpeg" ||
      typ === "image/jpg" ||
      typ === "image/tiff" ||
      typ === "text/plain" ||
      typ === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    );
  },
};
